import React from 'react'
import PropTypes from 'prop-types'
import { startCase } from 'lodash'
import { withNumeral } from 'utils/NumeralFormat'

const Content = (props) => {
  const cpv =
    (props.data.productType.slug === props.sponsorSlug)
    ? `${props.data.country.currencyCode} ${withNumeral(props.data.priceFixed / props.data.viewers)}`
    : ''
  const viewers =
    (props.data.productType.slug === props.sponsorSlug)
    ? `${props.data.viewers}`
    : ''
  const priceRange =
    (props.data.productType.slug === props.contentSlug)
    ? `${props.data.country.currencyCode} ${withNumeral(props.data.priceFixed)}`
    : ''
  const profileId = props.profile.profileId
  const ProfileName = props.profile.name
  const productType = props.data.service.name
  const format = props.data.format.name
  const description = props.data.description
  const languange = props.data.productLanguage.name
  const about = props.profile.about
  return (
    <table className="table table-hover table-light">
      <tbody>
        <tr key="profileName">
          <td width="400">Profile Name</td>
          <td>{ProfileName}</td>
        </tr>
        <tr key="profileID">
          <td width="400">Profile ID</td>
          <td>getcraft.com/{profileId}</td>
        </tr>
        <tr key="about">
          <td width="400">About</td>
          <td>{about}</td>
        </tr>
        <tr key="productType">
          <td width="400">Type</td>
          <td>{productType}</td>
        </tr>
        <tr key="format">
          <td width="400">Format</td>
          <td>{format}</td>
        </tr>
        <tr key="languange">
          <td width="400">Languange</td>
          <td>{languange}</td>
        </tr>
        {Object.keys(props.data).map((product) => {
          const changeTitle = {
            productTags: 'Topic',
            priceFixed: 'Price (Fixed)',
          }
          const title = (product in changeTitle)
            ? changeTitle[product]
            : product

          if (typeof props.data[product] !== 'object') {
            if (product === 'tags' || product === 'status' || product === 'id' || product === 'logo' || product === 'legacy' ||
              product === 'slug' || product === 'createdAt' || product === 'updatedAt' || product === 'isEligible' || product === 'isPublished' ||
              product === 'targetAgeFrom' || product === 'targetAgeTo' || product === 'description' || product === 'name' || product === 'viewers' ||
              product === 'priceFrom' || product === 'priceTo') {
              return null
            }
            const priceFields = [
              'priceFixed',
            ]
            let productValue = (
              priceFields.indexOf(product) >= 0
            )
              ? withNumeral(props.data[product])
              : String(props.data[product])
            if (priceFields.indexOf(product) >= 0) {
              productValue = `${props.data.country.currencyCode} ${productValue}`
              if (productValue === `${props.data.country.currencyCode} 0.00 `) {
                return null
              }
            }
            return (
              <tr key={product}>
                <td width="400">{startCase(title)}</td>
                <td>{productValue}</td>
              </tr>
            )
          }
          if (Array.isArray(props.data[product])) {
            const arrayContent = props.data[product].map(productField => productField?.name)
            return (
              <tr key={product}>
                <td width="400">{startCase(title)}</td>
                <td>{arrayContent.join(', ')}</td>
              </tr>
            )
          }
          if (product === 'createdAt' || product === 'updatedBy' || product === 'profile' || product === 'productType' ||
              product === 'createdBy' || product === 'legacy' || product === 'city' || product === 'country' || product === 'productLanguage' ||
              product === 'service' || product === 'format' || product === 'standard') {
            return null
          }
          return (
            <tr key={product}>
              <td width="400">{startCase(title)}</td>
              <td>
                {props.data[product].name

                  ? props.data[product].name
                  : props.data[product].first_name}
              </td>
            </tr>
          )
        })}
        {
          (viewers !== '')
          ? (
            <tr key="viewers">
              <td width="400">Guaranteed Views</td>
              <td>{viewers}</td>
            </tr>
          )
          : null
        }
        {
          (priceRange !== '')
          ? (
            <tr key="priceRange">
              <td width="400">Price Starting at</td>
              <td>{priceRange}</td>
            </tr>
          )
          : null
        }
        {
          (cpv !== '')
          ? (
            <tr key="cpv">
              <td width="400">Cost per View</td>
              <td>{cpv}</td>
            </tr>
          )
          : null
        }
        <tr key="description">
          <td width="400">Description</td>
          <td>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

Content.defaultProps = {
  data: PropTypes.shape({
    priceFixed: 0,
    priceFrom: 0,
    priceTo: 0,
    description: '',
    country: PropTypes.shape({
      currencyCode: '',
    }),
  }),
  profile: PropTypes.shape({
    name: '',
    profileId: '',
  }),
  sponsorSlug: '',
  contentSlug: '',
}

Content.propTypes = {
  data: PropTypes.shape({
    viewers: PropTypes.number,
    priceFixed: PropTypes.number,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    description: PropTypes.string.isRequired,
    service: PropTypes.shape({
      name: PropTypes.string,
    }),
    productType: PropTypes.shape({
      slug: PropTypes.string,
    }),
    country: PropTypes.shape({
      currencyCode: PropTypes.string,
      // name: PropTypes.string,
    }),
    format: PropTypes.shape({
      name: PropTypes.string,
    }),
    productLanguage: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  profile: PropTypes.shape({
    name: PropTypes.string,
    profileId: PropTypes.string,
    about: PropTypes.string,
  }),
  sponsorSlug: PropTypes.string,
  contentSlug: PropTypes.string,
}

export default Content
